import { AppRegistry } from "react-native";

import { ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "styled-components";
import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import { persistedStore, store } from "@redux";
import React from "react";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { getApolloClient as Client } from "components/src/apollo";
import { navigationRef } from "components/src/navigation";
import { DeeplinkConfigs, RootNavigator } from "./navigation";
import GlobalStyles, { theme } from "components/src/configuration/style/global.style";
import { AuthThunks } from "@modules";
import "components/src/utils/icons";
import { Config } from "../../../config";
import { LoaderAnimation } from "@atomic/atoms/LoaderAnimation";
import "react-toastify/dist/ReactToastify.css";
import { Toast } from "@atomic";
import { navigationPermission } from "@utils";
import { get } from "lodash";
import * as Sentry from "@sentry/react";

const Stack = createStackNavigator();

declare global {
  interface Window {
    config: Config;
  }
}

Sentry.init({
  dsn: window.config.SENTRY_URL_DSN,
  enabled: window.config.ENV !== 'development' // to prevent reporting errors in dev mode unintentionally
});

export function App() {
  // handle the the cat external link on the top of app, out of all auth logic
  if (get(window, "location.pathname", "").toLowerCase() === "/cat")
    window.location.replace(window.config.CAT_EXTERNAL_URL);

  // persistedStore.purge();
  store.dispatch(AuthThunks.initializeAuth0Client());

  if (!Client()) return null;
  return (
    <ThemeProvider theme={theme}>
      <ApolloProvider client={Client()}>
        <Provider store={store}>
          <PersistGate persistor={persistedStore}>
            <SafeAreaProvider>
              <NavigationContainer
                ref={navigationRef}
                linking={DeeplinkConfigs()}
                onStateChange={(state) => navigationPermission(state, store)}
                documentTitle={{
                  formatter: (options, route) => "Foodi",
                }}
              >
                <LoaderAnimation />
                <Toast />
                <Stack.Navigator initialRouteName={"Root"}>
                  <Stack.Screen
                    component={RootNavigator}
                    name={"Root"}
                    options={{ headerShown: false }}
                  />
                </Stack.Navigator>
              </NavigationContainer>
            </SafeAreaProvider>
          </PersistGate>
        </Provider>
      </ApolloProvider>
      <GlobalStyles />
    </ThemeProvider>
  );
}

declare let global: {
  HermesInternal?: boolean;
};


AppRegistry.registerComponent("myprojectname", () => App);
AppRegistry.runApplication("myprojectname", {
  rootTag: document.getElementById("root"),
});
